import React, { useState, useRef } from "react";
import "./ContactUs.css";
import { Navbar } from "./header";
import { Footer } from "./footer";
import { supabase } from "../supabaseClient";

export const ContactUs = () => {
  const formRef = useRef(null);
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    const formData = new FormData(e.target);

    const data = {
      first_name: formData.get('firstName'),
      last_name: formData.get('lastName'),
      phone: formData.get('number'),
      email: formData.get('email'),
      event_type: formData.get('eventType'),
      how_did_you_hear: formData.get('howDidYouHearAboutUs'),
      event_date: formData.get('eventDates'),
      location: formData.get('location'),
      other_details: formData.get('otherDetails'),
    };

    try {
      if (!supabase) throw new Error('Service not configured yet.');

      const { error: dbError } = await supabase
        .from('contacts')
        .insert([data]);

      if (dbError) throw new Error(dbError.message);

      // Send email notification via edge function (non-blocking — form success is not dependent on email delivery)
      supabase.functions.invoke('send-email', {
        body: { type: 'contact', data },
      }).catch(() => {});

      setSubmitted(true);
      formRef.current.reset();
    } catch (err) {
      setError('Failed to submit form. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const ContactContent = () => (
    <>
      <div className="contact-hero">
        <h1 className="contact-hero-title">Get in Touch</h1>
        <div className="title-line"></div>
        <p className="contact-hero-subtitle">Let's create something beautiful together</p>
      </div>

      <div className="contact-main">
        <div className="contact-form-section">
          <div className="contact-container">
            <div className="form-header">
              <h2>Contact Us</h2>
              <p>Share your vision with us, and let's bring it to life through our lens.</p>
            </div>

            {error && (
              <div className="error-message">
                {error}
              </div>
            )}

            <form ref={formRef} onSubmit={handleSubmit} className="luxury-form">
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="firstName">First Name</label>
                  <input 
                    id="firstName"
                    type="text" 
                    name="firstName" 
                    placeholder="Your first name"
                    required 
                    disabled={loading}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="lastName">Last Name</label>
                  <input 
                    id="lastName"
                    type="text" 
                    name="lastName" 
                    placeholder="Your last name"
                    required 
                    disabled={loading}
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="number">Phone Number</label>
                  <input 
                    id="number"
                    type="tel" 
                    name="number" 
                    placeholder="Your contact number"
                    required 
                    disabled={loading}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <input 
                    id="email"
                    type="email" 
                    name="email" 
                    placeholder="Your email address"
                    required 
                    disabled={loading}
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="eventType">Type of Event</label>
                <select 
                  id="eventType"
                  name="eventType" 
                  required
                  disabled={loading}
                >
                  <option value="">Select event type</option>
                  <option value="wedding">Wedding</option>
                  <option value="engagement">Engagement</option>
                  <option value="portrait">Portrait Session</option>
                  <option value="commercial">Commercial</option>
                  <option value="other">Other</option>
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="howDidYouHearAboutUs">How did you hear about us?</label>
                <select 
                  id="howDidYouHearAboutUs"
                  name="howDidYouHearAboutUs" 
                  required
                  disabled={loading}
                >
                  <option value="">Select an option</option>
                  <option value="instagram">Instagram</option>
                  <option value="printerest">Printerest</option>
                  <option value="google">Google</option>
                  <option value="referral">Referral</option>
                  <option value="facebook">Facebook</option>
                  <option value="other">Other</option>
                </select>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="eventDates">Event Date</label>
                  <input 
                    id="eventDates"
                    type="date" 
                    name="eventDates" 
                    required 
                    disabled={loading}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="location">Location/Venue</label>
                  <input 
                    id="location"
                    type="text" 
                    name="location" 
                    placeholder="Event location or venue"
                    required 
                    disabled={loading}
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="otherDetails">Additional Details</label>
                <textarea 
                  id="otherDetails"
                  name="otherDetails" 
                  placeholder="Share any additional details about your vision..."
                  rows="4"
                  disabled={loading}
                />
              </div>

              <button 
                type="submit" 
                className="submit-button"
                disabled={loading}
              >
                {loading ? 'Sending...' : 'Send Message'}
              </button>
            </form>
          </div>
        </div>

        <div className="contact-info-section">
          <div className="info-container">
            <div className="info-item">
              <h3>Visit Us</h3>
              <p> 7/198, Swaroop Nagar</p>
              <p>Kanpur, Uttar Pradesh 208002</p>
            </div>
            <div className="info-item">
              <h3>Contact Info</h3>
              <p>hello@storiesbykalakaar.in</p>
              <p>+91 7355407103, +91 8957780465</p>
            </div>
            <div className="info-item">
              <h3>Follow Us</h3>
              <div className="social-links">
                <a href="https://www.instagram.com/kalakaarr_?igsh=b2dnMnExa244NHIz">Instagram</a>
                <a href="https://in.pinterest.com/storiesbykalakaar/">Printerest</a>
                <a href="https://www.youtube.com/@StoriesbyKalakaar">YouTube</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );

  return (
    <div className="contact-page">
      <Navbar />
      {submitted ? (
        <div className="thank-you-section">
          <h2>Thank You for Reaching Out</h2>
          <p>We appreciate your interest in our photography services.</p>
          <p>We will get back to you within 24-48 hours.</p>
          <div className="contact-details">
            <p>In the meantime, you can reach us at:</p>
            <p>hello@storiesbykalakaar.in</p>
            <p>+91 7355407103, +91 8957780465</p>
          </div>
        </div>
      ) : (
        <ContactContent />
      )}
      <Footer />
    </div>
  );
};
